import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppServiceManager } from 'common/services/appServiceManager';
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { NgxSpinnerService } from 'ngx-spinner';
import { Configuration } from 'config/config';
import { ClipboardService } from 'ngx-clipboard';
import { AppUtils } from 'common/services/app.util';
import { IBranch } from 'app/shared/Domains/branch';
import { IUser } from 'app/shared/Domains/IUser';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css'],
  animations: [
    trigger('menu', [
      state('hidden', style({
        height: '0px'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class PaymentComponent {
  active: boolean = true;
  payment: boolean;
  previewUrl: string;
  selectedFile: File;
  memberId: any;
  month: any;
  year: any;
  branches: IBranch;
  user: IUser;
  member: any;
  isEmailLoader: boolean = false;
  isPaid: boolean = false;
  payments: any;
  feeDetails: any;
  feeDetail: any;
  displayMonth: any;
  paidMsg: string = "The Fee Has Been Paid Already.";
  isSuccess: boolean;
  isError: boolean;
  message: string;
  selectedBranch: any;
  branch: string;
  company: string;
  balance: number;
  numOfMonths: number;
  //branches = branches;
  isAccountCopied: boolean[] = [];
  isIBANCopied: boolean[] = [];

  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PaymentComponent", label);
  }


  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private appServiceManager: AppServiceManager,
    private route: ActivatedRoute,
    public config: Configuration,
    private loader: NgxSpinnerService,
    private clipboardService: ClipboardService,

  ) { }
  ngOnInit(): void {
    this.branches = new IBranch();
    this.route.queryParamMap.subscribe(params => {
      console.log('memberid:', params.get('memberid'));
      console.log('month:', params.get('month'));
      console.log('year:', params.get('year'));
      console.log('company:', params.get('company'));
      console.log('branch:', params.get('branch'));
      this.memberId = params.get('memberid');
      this.month = params.get('month');
      this.year = params.get('year');
      this.company = params.get('company');
      this.branch = params.get('branch');
      this.displayMonth = AppUtils.getMonthName(this.month);
      this.getBranchById();
      if (this.memberId !== null && this.memberId !== undefined) {
        this.getCustomerById();
      } else {
      }
    });
  }

  getBranchById() {
    this.appServiceManager.get('branches/'+ this.branch ).subscribe(
      (res) => {
        if (res) {
          this.selectedBranch = res;
        } else {
          this.branches = new IBranch();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.branches = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }


  onClick(event): void {
    this.active = !this.active;
    setTimeout(() => {
    }, 450);
    // event.preventDefault();
  }
  onPayment(event) {
    this.payment = !this.payment;
    setTimeout(() => {
    }, 450);
    event.preventDefault();
  }

  fileChangeEvent(event: any): void {
    const file: File = event.target.files[0];
    const fileReader: FileReader = new FileReader();

    fileReader.onloadend = (loadEvent: any) => {
      this.previewUrl = loadEvent.target.result;
      console.log(this.previewUrl);
    };

    fileReader.readAsDataURL(file);

    // Append string to the file name
    const modifiedFileName = file.name + ":" + this.company + ":" + this.branch;
    const modifiedFile = new File([file], modifiedFileName, { type: file.type });
    this.selectedFile = modifiedFile;
    //this.selectedFile = file;
    this.message = '';
  }

  submit() {
    this.uploadReceipt(this.selectedFile);
  }

  errorMsgClose() {
    this.isError = false;
    this.isSuccess = false;
  }

  copyToClipboard(accountNumber: string, index: number, type: string) {
    this.clipboardService.copyFromContent(accountNumber);

    if (type === 'account') {
      this.isAccountCopied[index] = true;

      setTimeout(() => {
        this.isAccountCopied[index] = false;
      }, 3000);
    } else if (type === 'iban') {
      this.isIBANCopied[index] = true;

      setTimeout(() => {
        this.isIBANCopied[index] = false;
      }, 3000);
    }
  }

  uploadReceipt(file: any) {
    this.isEmailLoader = true;
    let formData: FormData = new FormData();
    if (file) {
      formData.append("feeReceiptImage", file, file.name);
      formData.append("month", this.month);
      formData.append("year", this.year);
      formData.append("name", this.member?.name);
      formData.append("mobile", this.member?.contactDetail.contact);
      formData.append("email", this.member?.email);
      formData.append("gender", this.member?.gender);
      formData.append("monthFee", this.member?.monthFee);
      formData.append("branch", this.member?.branch);
      formData.append("company", this.member?.company);
      formData.append("tagNumber", this.member?.tagNumber);
      formData.append("memberId", this.member?._id);

      this.appServiceManager.post("requests/upload/feereceipt", formData)
        .subscribe(
          (res: any) => {
            this.message = "Thank you for submitting fee receipt.";
            this.isSuccess = true;
            this.isError = false;
            this.previewUrl = '';
            setTimeout(() => {
              this.isEmailLoader = false;

            }, 3000);
          },
          (error) => {
            this.message = "Something went wrong.";
            this.isSuccess = false;
            this.isError = true;
            setTimeout(() => {
              this.isEmailLoader = false;

            }, 1000);
            //this.MessageService.clear();
            // this.MessageService.add({
            //   severity: "error",
            //   summary: "Error Message",
            //   detail: error,
            // });
          }
        );
    }
  }

  getCustomerById() {
    this.appServiceManager.get("customers/" + this.memberId).subscribe((res: any) => {
      if (res) {
        this.member = res;
        this.getPackagesByID();
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong.' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  getPackagesByID() {
    //console.log("this.member.packageId",this.member.packageId)
    this.appServiceManager
        .get(
            "packagesBuilder/" +
            this.member.packageId
        )
        .subscribe(
            (res) => {
                this.numOfMonths = res.noOfMonths;
                this.calculateFee();
                console.log("No. of Month(s)",this.numOfMonths);

            },
            (error: any) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );

  }

  calculateFee() {
    let paidAmount = 0;

    this.feeDetails = this.member.feeDetails.filter(fee => fee.month == this.month
      && fee.year == this.year
      && fee.status == 'Monthly Fee - Paid');

    if (this.feeDetails.length > 0) {
      for (let i = 0; i < this.feeDetails.length; i++) {
        paidAmount += parseInt(this.feeDetails[i].pay);
        this.feeDetails[i].month =AppUtils.getMonthName(this.feeDetails[i].month);
      }
    }

    // if (paidAmount >= parseInt(this.member.monthFee)) {
    //   this.isPaid = true;
    // }
    // else {
    //   this.isPaid = false;
    //   this.balance = parseInt(this.member.monthFee) - paidAmount;
    // }
    const dueDate = new Date(this.member.settings.dueDate);
    const todatDate = new Date();
    if (dueDate > todatDate) {
      this.isPaid = true;
    }
    else {
      this.isPaid = false;
      this.balance = parseInt(this.member.monthFee)* this.numOfMonths;
    }
  }
}